import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #TABLE-HEADER-CELL
\*------------------------------------ */
:host {
  display: contents;
}

/**
 * Table header cell
 * 1) The main table header cell (th) within the table header and row
 */
.cat-c-table-header-cell {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: var(--cat-table-column-min-width, calc(var(--size-base-unit) * 17.5));
  min-height: calc(var(--size-base-unit) * 4);
  height: 100%;
  padding: var(--cat-c-table-header-cell-padding, var(--cat-space-2x-small) var(--cat-space-medium) calc(var(--cat-space-2x-small) - 1px));
  border-block-end: 1px solid var(--cat-theme-color-border-subtle);
  color: var(--cat-theme-color-content-strong);
  background-color: var(--cat-theme-color-background-default);
  z-index: var(--cat-table-header-cell-zindex-pass-down, var(--cat-table-header-cell-zindex, var(--cat-z-index-200)));
}
.cat-c-table-header-cell:hover:not(.cat-c-table-header-cell--loader), .cat-c-table-header-cell:focus {
  background-color: var(--cat-theme-color-table-alternate-hover);
  color: var(--cat-theme-color-content-strong-hover);
  cursor: default;
}

::slotted(cat-tooltip) {
  font-weight: normal;
}

.cat-c-table-header-icon-slot {
  position: absolute;
  inset-inline-start: 0;
  inset-block-end: calc(var(--size-base-unit) * 0.25);
  padding-inline-start: var(--cat-space-small);
  padding-block: var(--cat-c-slot-accordion-padding-bottom, 0);
  z-index: 1000;
}

/**
 * Align right
 * If align right is true, then align the content to right of the cell
 */
.cat-c-table-header-cell--align-right {
  align-items: end;
  justify-content: flex-end;
}

/**
 * Align center
 * If align center is true, then align the content to center of the cell
 */
.cat-c-table-header-cell--align-center {
  align-items: center;
  justify-content: center;
}

/**
 * Table header cell sortable and filter
 * 1) Hover/focus state if the cell behavior is sortable or filter
 */
.cat-c-table-header-cell--sortable,
.cat-c-table-header-cell--filter {
  --cat-c-table-header-cell-padding: 0;
  --cat-c-slot-accordion-padding-bottom: 4px;
}
.cat-c-table-header-cell--sortable.cat-c-table-header-cell--loader,
.cat-c-table-header-cell--filter.cat-c-table-header-cell--loader {
  padding: var(--cat-space-3x-small) var(--cat-space-medium);
}

/**
 * Table header cell button
 * 1) If sortable or has filter, then the content is inside a button.
 */
.cat-c-table-header-cell__button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  appearance: none;
  outline: none;
  border: 0;
  background: 0;
  margin: 0;
  padding: var(--cat-c-table-header-cell__button-padding, var(--cat-space-2x-small) var(--cat-space-medium));
  padding-block-end: calc(var(--cat-space-2x-small) - 1px);
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;
  text-align: start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: unset;
  /**
   * Table header cell hover/focus state
   */
  /**
   * Table header cell focus visible state
   * 1) Adds focus state when you tab through the table header cells
   * 2) Only apply if parent does not have class cat-is-active-filter
   */
  /**
   * If align right is true, then align the content var(--rtlGradientToRight, 90deg) of the button
   */
  /**
   * If align center is true, then align the content to center of the button
   */
  /**
   * If isExpandable or isDraggable, the shift over the button to align with the cell text
   */
}
.cat-c-table-header-cell__button:hover, .cat-c-table-header-cell__button:focus {
  cursor: pointer;
}
.cat-c-table-header-cell__button:focus-visible:not(.cat-is-active-filter .cat-c-table-header-cell__button) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-table-header-cell--align-right .cat-c-table-header-cell__button {
  align-items: flex-end;
  text-align: end;
}
.cat-c-table-header-cell--align-center .cat-c-table-header-cell__button {
  align-items: center;
  text-align: center;
}
.cat-is-expandable .cat-c-table-header-cell__button, .cat-is-draggable .cat-c-table-header-cell__button {
  padding-inline-start: calc(var(--size-base-unit) * 7.5);
}

/**
 * Table header cell header
 * 1) The container for the sortable/filter triggers and default slot content
 */
.cat-c-table-header-cell__heading {
  position: relative;
  display: flex;
  align-items: flex-end;
  width: 100%;
}

/**
 * Table header cell title
 * 1) The container for the default slot content inside the table header cell
 */
.cat-c-table-header-cell__title {
  /**
   * Table header cell tooltip
   * 1) Line clamp the content if it goes over two lines
   */
}
.cat-c-table-header-cell__button .cat-c-table-header-cell__title {
  flex: 1;
}
.cat-c-table-header-cell--tooltip .cat-c-table-header-cell__title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/**
 * Table header cell description
 * 1) The container for the description slot content inside the table header cell
 * 2) Fix for cell hover to activate tooltip
 */
.cat-c-table-header-cell__description {
  font-weight: normal;
  pointer-events: none;
  color: var(--cat-theme-color-content-strong);
}
.cat-c-table-header-cell:hover .cat-c-table-header-cell__description, .cat-c-table-header-cell:focus .cat-c-table-header-cell__description {
  color: var(--cat-theme-color-content-strong-hover);
}
.cat-c-table-header-cell--ascending .cat-c-table-header-cell__description, .cat-c-table-header-cell--descending .cat-c-table-header-cell__description, .cat-c-table-header-cell--sortable .cat-c-table-header-cell__description {
  margin-inline-start: var(--cat-space-x-large);
}

/**
 * Table header cell sortable icon
 * 1) The icon that displays if the table header cell is sortable
 */
.cat-c-table-header-cell__sortable-icon {
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
  margin-inline-end: var(--cat-space-x-small);
  padding-block-end: calc(var(--size-base-unit) * 0.25);
}

/**
 * Table header cell filter icon
 * 1) The icon that displays if the table header cell has a filter
 */
.cat-c-table-header-cell__filter-icon {
  margin-inline-start: var(--cat-space-x-small);
  padding-block-end: calc(var(--size-base-unit) * 0.25);
}

/**
 * Table header cell filter
 * 1) The dropdown panel for the filter
 */
.cat-c-table-header-cell__filter {
  position: absolute;
  inset-block-start: 100%;
  inset-inline-start: var(--cat-space-medium);
  z-index: var(--cat-z-index-300);
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  /**
   * 1) Show the filter dropdown panel if active is true
   */
  /**
   * 1) If is expandable or draggable is true, then align the filter dropdown panel with the cell content
   */
  /**
   * 1) If is bulk action, then align the filter dropdown panel with the cell content
   */
  /**
   * If align right is true, then align the filter dropdown panel to the right of the cell
   */
  /**
   * If align center is true, then align the filter dropdown panel to the center of the cell
   */
}
.cat-is-active-filter .cat-c-table-header-cell__filter {
  opacity: 1;
  visibility: visible;
}
.cat-is-expandable:not(.cat-c-table-header-cell--align-right, .cat-c-table-header-cell--align-center) .cat-c-table-header-cell__filter, .cat-is-draggable:not(.cat-c-table-header-cell--align-right, .cat-c-table-header-cell--align-center) .cat-c-table-header-cell__filter {
  inset-inline-start: calc(var(--size-base-unit) * 7.5);
}
.cat-is-bulk-action:not(.cat-c-table-header-cell--align-right, .cat-c-table-header-cell--align-center) .cat-c-table-header-cell__filter {
  inset-inline-start: var(--cat-space-5x-large);
}
.cat-c-table-header-cell--align-right .cat-c-table-header-cell__filter {
  inset-inline: auto var(--cat-space-medium);
}
.cat-c-table-header-cell--align-center .cat-c-table-header-cell__filter {
  inset-inline-start: 50%;
  transform: translateX(var(--rtlTranslateX, -50%));
}

/**
 * Table header cell active shadow
 * 1) If isActiveShadow is set to true, then add a shadow to the right on scrollLeft
 * 2) Add 1px to the height to account for the borders
 */
.cat-is-active-shadow {
  position: relative;
}
.cat-is-active-shadow:after {
  content: "";
  display: block;
  position: absolute;
  background: linear-gradient(var(--rtlGradientToRight, to right), rgba(0, 0, 0, 0.19) 0%, rgba(0, 0, 0, 0) 100%);
  height: calc(100% + 1px); /* 2 */
  inset-block-start: 0;
  inset-inline-end: calc(calc(var(--size-base-unit) * 1.125) * -1);
  width: calc(var(--size-base-unit) * 1.125);
  z-index: -1;
}

/**
 * Shift over the shadow to not cover the right border
 */
.cat-is-active-shadow.cat-c-table-header-cell--border-right.cat-c-table-header-cell--frozen:after {
  inset-inline-end: calc(calc(var(--size-base-unit) * 1.125) * -1 - 1px);
}

/**
 * Table cell bulk action
 * 1) If isBulkAction is true, then align the content in a row.
 */
.cat-is-bulk-action {
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
}

/**
 * Table cell expandable and draggable
 * 1) If isExpandable or isDraggable is true, then align the content to the table cells
 */
.cat-is-expandable:not(.cat-c-table-header-cell--filter, .cat-c-table-header-cell--sortable),
.cat-is-draggable:not(.cat-c-table-header-cell--filter, .cat-c-table-header-cell--sortable) {
  padding-inline-start: calc(var(--size-base-unit) * 7.5);
}

/**
 * Table cell checkox
 * 1) The inline checkbox that appears if bulk actions is true.
 */
.cat-c-table-header-cell__checkbox {
  margin-inline-end: var(--cat-space-medium);
  margin-block-end: calc(var(--size-base-unit) * 0.25);
  --cat-checkbox-field-margin-top: 0;
}
.cat-c-table-header-cell--sortable .cat-c-table-header-cell__checkbox, .cat-c-table-header-cell--filter .cat-c-table-header-cell__checkbox {
  margin-inline: var(--cat-space-medium) 0;
  margin-block: var(--cat-space-3x-small);
}

/**
 * Table header cell tooltip trigger
 * 1) The trigger slot inside the tooltip
 * 2) Aligns the content to the bottom of the cell
 */
.cat-c-table-header-cell__tooltip-trigger {
  display: flex;
  position: relative;
}

/**
 * Table header cell border right
 * 1) Adds a border to the right of the cell
 */
.cat-c-table-header-cell--border-right {
  border-inline-end: 1px solid var(--cat-theme-color-border-subtle);
}

/**
 * Table header cell border top
 * 1) Adds a border to the top of the cell
 */
.cat-c-table-header-cell--border-top {
  border-block-start: 1px solid var(--cat-theme-color-border-subtle);
}

/**
 * Table header cell border top right
 * 1) Adds a border to the top and right of the cell
 */
.cat-c-table-header-cell--border-top-right {
  border-block-start: 1px solid var(--cat-theme-color-border-subtle);
  border-inline-end: 1px solid var(--cat-theme-color-border-subtle);
}

/**
 * Table header cell border bottom none
 * 1) Removes a border to the bottom of the cell
 */
.cat-c-table-header-cell--border-bottom-none {
  border-block-end: none;
}

/**
 * Table header cell border bottom none
 * 1) Removes a border to the bottom of the cell
 */
.cat-c-table-header-cell--border-right-only {
  border-block-end: 1px solid transparent;
  border-inline-end: 1px solid var(--cat-theme-color-border-subtle);
}

/**
 * Table header cell frozen
 * 1) If frozen is true, then make the table header cell sticky
 */
.cat-c-table-header-cell--frozen {
  position: sticky;
  inset-block-start: 0;
  inset-inline-start: var(--cat-table-header-cell-left, 0);
  background-color: var(--cat-theme-color-background-default);
}

/**
 * Table header cell sticky
 * 1) If isSticky then make the cell sticky on scroll
 */
.cat-c-table-header-cell--sticky {
  position: sticky;
  inset-block-start: 0;
  inset-inline-start: var(--cat-table-header-cell-sticky-left, 0);
  z-index: var(--cat-z-index-300);
}

/**
 * Table header cell mobile view
 * 1) If isMobileView then set the border to transparent
 */
.cat-is-mobile-view {
  border-inline-end: 1px solid transparent;
  /**
     * Visually remove aria-hidden cells on the mobile view, so an empty cell does not display
     */
}
.cat-is-mobile-view[aria-hidden] {
  display: var(--cat-table-header-column-display);
  border-width: var(--cat-table-header-column-border-width);
}

.cat-c-table-header-cell:not(.cat-c-table-header-cell--has-description) .cat-c-table-header-cell__description, .cat-c-table-header-cell:not(.cat-c-table-header-cell--has-icon) .cat-c-table-header-icon-slot, .cat-c-table-header-cell:not(.cat-c-table-header-cell--has-filter) [part=part-filter] {
  display: none;
}
`;
       